// useSendSetupEmail.ts
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";

import backendClient from "src/api";

export const useSendSetupEmail = () => {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  const sendSetupEmail = (email: string) => {
    backendClient.auth
      .generateSetupEmail({ email })
      .then(() => {
        enqueueSnackbar(
          "We sent you a password setup link. Please check your inbox",
          { variant: "success" }
        );
      })
      .finally(() => {
        navigate("/password-setup-confirmation-sent", {
          state: { email },
        });
      });
  };

  return sendSetupEmail;
};
